import * as React from 'react';

import { INotificationState } from '../../types/redux/notificator';
import { PriceNotificator } from '../../components/Notificator';

interface IParams {
  price: string;
  onActionClick: React.MouseEventHandler;
}

export const getEstimationUpdatedNotificationVarA = (params: IParams): INotificationState => {
  return {
    isOpen: true,
    duration: 5000,
    content: (
      <PriceNotificator
        content={`Новая оценка — ${params.price}`}
        actionText="Посмотреть"
        onActionClick={params.onActionClick}
      />
    ),
  };
};

export const getEstimationUpdatedNotificationVarB = (params: IParams): INotificationState => {
  return {
    isOpen: true,
    duration: 5000,
    content: (
      <PriceNotificator
        content={`Новая оценка — ${params.price}\nЕсли уточните параметры квартиры, то мы подберем другие объявления`}
        actionText="Уточнить"
        onActionClick={params.onActionClick}
      />
    ),
  };
};
